import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "segment-item" }
const _hoisted_2 = { class: "row-number" }
const _hoisted_3 = { class: "text" }
const _hoisted_4 = { class: "text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SourceSegment = _resolveComponent("SourceSegment")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.rowNumber), 1),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_SourceSegment, {
        modelValue: _ctx.modelValue.sourceData
      }, null, 8, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_SourceSegment, {
        modelValue: _ctx.modelValue.draftData
      }, null, 8, ["modelValue"])
    ])
  ]))
}